module.exports = __webpack_public_path__ + "static/media/Button-SoundBible.com-1420500901.0bc53d4f.mp3";